import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { Provider } from 'react-redux';
import Amplify from '@aws-amplify/auth';
import App from './App';
import store from './app/store';
import * as serviceWorker from './serviceWorker';
import config from './config';

window.LOG_LEVEL = config.LOG_LEVEL;

Amplify.configure({
  Auth: {
    region: config.COGNITO_REGION,
    userPoolId: config.COGNITO_USERPOOL_ID,
    userPoolWebClientId: config.COGNITO_CLIENT_ID,
    authenticationFlowType: 'USER_SRP_AUTH',
    // Local only: route Amplify at the mock-aws endpoint. Falls back to real Cognito when unset.
    ...(config.COGNITO_ENDPOINT ? { endpoint: config.COGNITO_ENDPOINT } : {}),
    oauth: {
      domain: config.COGNITO_DOMAIN,
      scope: [
        'phone',
        'email',
        'profile',
        'openid',
        'aws.cognito.signin.user.admin',
      ],
      redirectSignIn: `${config.COGNITO_REDIRECT_URL}/login/success`,
      redirectSignOut: `${config.COGNITO_REDIRECT_URL}/login`,
      responseType: 'code',
    },
  },
});
ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
